import { render, staticRenderFns } from "./ExamQuestion.vue?vue&type=template&id=8073b698&scoped=true&"
import script from "./ExamQuestion.vue?vue&type=script&lang=js&"
export * from "./ExamQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ExamQuestion.vue?vue&type=style&index=0&id=8073b698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8073b698",
  null
  
)

export default component.exports